import tos_AT from "./pages/shared/terms/AcceptTerms_AT.md";
import tos_BE from "./pages/shared/terms/AcceptTerms_BE.md";
import tos_CH from "./pages/shared/terms/AcceptTerms_CH.md";
import tos_DE from "./pages/shared/terms/AcceptTerms_DE.md";
import tos_DK from "./pages/shared/terms/AcceptTerms_DK.md";
import tos_FI from "./pages/shared/terms/AcceptTerms_FI.md";
import tos_FR from "./pages/shared/terms/AcceptTerms_FR.md";
import tos_NL from "./pages/shared/terms/AcceptTerms_NL.md";
import tos_NO from "./pages/shared/terms/AcceptTerms_NO.md";
import tos_SE from "./pages/shared/terms/AcceptTerms_SE.md";
import tos_UK from "./pages/shared/terms/AcceptTerms_UK.md";

export type CountryUrls = {
    root: string,
    becomePartnerUrl: string,
    requestLoginUrl: string,
    tos: string
}

const dictionary: { [key: string]: CountryUrls } = {
    'at': {
        root: 'https://infinigate.at/IDconnect',
        becomePartnerUrl: 'https://infinigate.at/Services/Formulare/Partner-werden',
        requestLoginUrl: 'https://infinigate.at/Services/Formulare/Anmeldung-Partnerwelt',
        tos: tos_AT,
    },
    'be': {
        root: 'https://infinigate.be/IDconnect',
        becomePartnerUrl: 'https://infinigate.be/en/Services/Partner-Requests/Become-a-partner',
        requestLoginUrl: 'https://infinigate.be/en/Services/Partner-Requests/Partner-World-and-eShop-login',
        tos: tos_BE,
    },
    'ch': {
        root: 'https://infinigate.ch/IDconnect',
        becomePartnerUrl: 'https://infinigate.ch/Services/Formulare/Partner-werden/',
        requestLoginUrl: 'https://infinigate.ch/Services/Formulare/Webshop-Login/',
        tos: tos_CH,
    },
    'de': {
        root: 'https://infinigate.de/IDconnect',
        requestLoginUrl: 'https://infinigate.de/Services/Formulare/Webshop-Login/',
        becomePartnerUrl: 'https://infinigate.de/Services/Formulare/Partner-werden/',
        tos: tos_DE,
    },
    'dk': {
        root: 'https://infinigate.dk/IDconnect',
        becomePartnerUrl: 'https://infinigate.dk/Services/Formularer/Bliv-forhandler/',
        requestLoginUrl: 'https://infinigate.dk/Services/Formularer/Registrer-dig-til-webshop/',
        tos: tos_DK,
    },
    'fi': {
        root: 'https://infinigate.fi/IDconnect',
        becomePartnerUrl: 'https://infinigate.fi/Services/Formulare/Partner-werden/',
        requestLoginUrl: 'https://infinigate.fi/Palvelut/Lomakkeet/Hae-webshop-tunnuksia/',
        tos: tos_FI,
    },
    'fr': {
        root: 'https://infinigate.fr/IDconnect',
        becomePartnerUrl: 'https://infinigate.fr/Services/Demandes-des-partenaires/Devenir-partenaire',
        requestLoginUrl: 'https://infinigate.fr/Services/Demandes-des-partenaires/Portail-partenaire-et-eshop',
        tos: tos_FR,
    },
    'se': {
        root: 'https://infinigate.se/IDconnect',
        becomePartnerUrl: 'https://infinigate.se/Tjaenster/Bli-partner-och-kund-till-Infinigate/',
        requestLoginUrl: 'https://infinigate.se/Tjaenster/Partnerportal-med-webshop/',
        tos: tos_SE,
    },
    'no': {
        root: 'https://infinigate.no/IDconnect',
        becomePartnerUrl: 'https://infinigate.no/Tjenester/Skjema/Bli-partner',
        requestLoginUrl: 'https://infinigate.no/Tjenester/Skjema/Webshop-tilgang',
        tos: tos_NO,
    },
    'nl': {
        root: 'https://infinigate.nl/IDconnect',
        becomePartnerUrl: 'https://infinigate.nl/en/Services/Partner-Requests/Become-a-partner',
        requestLoginUrl: 'https://infinigate.nl/en/Services/Partner-Requests/Partner-World-and-eShop-login',
        tos: tos_NL,
    },
    'uk': {
        root: 'https://idconnect.infinigate.com/uk/en',
        becomePartnerUrl: 'https://infinigate.co.uk/Services/Partner-Requests/Become-a-partner',
        requestLoginUrl: 'https://infinigate.co.uk/Services/Partner-Requests/Request-access-to-ID-Connect',
        tos: tos_UK,
    },
}

export const countryButtons = (countryCode: string): CountryUrls|null => {
    if (countryCode in dictionary) {
        return dictionary[countryCode];
    }
    return null;
};

export const getTos = (countryCode: string|null): string => {
    if (countryCode === null || !(countryCode in dictionary)) {
        return dictionary['de'].tos;
    }
    return dictionary[countryCode].tos;
};

export const extractCountryCodeFromUrl = (url: string): string | Error => {
    try {
        const urlObj = new URL(url);
        let [tld, , subdomain] = urlObj.hostname.split('.').reverse();
        // On dev it's {countryCode}.infinigate.dev, on Live its infinigate.{countryCode}
        if (tld === 'dev') tld = subdomain;
        return tld;
    } catch (_) {
        return new Error('no valid url given');
    }
}

export const isKnownCountry = (countryCode: string): boolean => countryCode in dictionary;
